import { AttrTypeName } from "src/types/AttrType";
import { ZAttribute } from "src/types/ZAttribute";
import { ZUid } from "src/types/zUid";

/**
 * Кандидаты для backlinkAttributeId: прямые «Ссылка на другой объект» на цели,
 * которые ссылаются на объект настройки.
 */
export const filterBacklinkCandidateAttrs = (
  attrs: ZAttribute[],
  currentObjectId: ZUid,
  attrTypesDict: Record<number, string>,
  excludeAttrId?: ZUid,
): ZAttribute[] =>
  attrs.filter(
    ({ id, valueType, referenceId }) =>
      attrTypesDict[valueType] === AttrTypeName.object &&
      referenceId === currentObjectId &&
      id !== excludeAttrId,
  );
